
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/winners/[...slug]",
      function () {
        return require("private-next-pages/winners/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/winners/[...slug]"])
      });
    }
  